import { erpAxios } from '..';

const getStatus = async () => {
  const { data } = await erpAxios(`/gr-status-zahtjeva/statusZahtjeva`);
  return data;
};

export default getStatus;
